module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/178.42ff812a.png";